/**
 * Quick Add to Cart functionality for product cards
 * Shows size selector and add to cart button on hover (desktop)
 * Shows modal on mobile when clicking icon
 */
(function() {
    'use strict';

    // Modal elements (lazy-initialized to ensure DOM is ready)
    let modal = null;
    let modalOverlay = null;
    let modalClose = null;
    let modalHeader = null;
    let modalTitle = null;
    let modalSizesContainer = null;
    let modalAddBtn = null;
    let modalInitialized = false;
    
    let currentSelectedVariantId = null;
    
    function ensureModalElements() {
        if (modalInitialized) return !!modal;
        modal = document.getElementById('bfs-quick-add-modal');
        if (!modal) return false;
        modalOverlay = modal.querySelector('.bfs-quick-add-modal__overlay');
        modalClose = modal.querySelector('.bfs-quick-add-modal__close');
        modalHeader = modal.querySelector('.bfs-quick-add-modal__header');
        modalTitle = modalHeader ? modalHeader.querySelector('.bfs-quick-add-modal__title') : null;
        modalSizesContainer = document.getElementById('bfs-quick-add-modal-sizes');
        modalAddBtn = document.getElementById('bfs-quick-add-modal-add-btn');
        modalInitialized = true;
        
        // Attach modal event listeners once found
        if (modalClose) {
            modalClose.addEventListener('click', function(e) {
                e.preventDefault();
                closeModal();
            });
        }
        if (modalOverlay) {
            modalOverlay.addEventListener('click', function(e) {
                e.preventDefault();
                closeModal();
            });
        }
        if (modalAddBtn) {
            modalAddBtn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                if (!currentSelectedVariantId || this.disabled || this.classList.contains('is-adding')) {
                    return;
                }
                
                var btn = this;
                addToCart(currentSelectedVariantId, btn, false).then(function() {
                    setTimeout(function() {
                        closeModal();
                        btn.textContent = 'Add to cart';
                        btn.style.background = '';
                        btn.disabled = false;
                        btn.classList.remove('is-added', 'is-adding');
                    }, 1500);
                }).catch(function(error) {
                    console.error('Error adding to cart:', error);
                });
            });
        }
        
        return !!modal;
    }
    
    // Open modal with product data
    function openModal(productHandle, productData) {
        // Store product handle for later use
        if (!productHandle && productData && productData.handle) {
            productHandle = productData.handle;
        }
        // Ensure modal elements are resolved
        ensureModalElements();
        if (!modal || !modalSizesContainer || !modalAddBtn) {
            console.error('Modal elements not found');
            return;
        }
        
        currentSelectedVariantId = null;
        
        // Clear previous sizes
        modalSizesContainer.innerHTML = '';
        
        // Check if product is personalized first
        let isPersonalised = false;
        let personalisationOptionIndex = -1;
        
        // Check product tags
        if (productData.tags && Array.isArray(productData.tags)) {
            isPersonalised = productData.tags.some(function(tag) {
                return tag && (tag.includes('_badge:Personalise') || tag.includes('COLLECTION_Personalised Product'));
            });
        }
        
        // Check for exact "Personalised" option name
        if (productData.options && Array.isArray(productData.options)) {
            productData.options.forEach(function(opt, index) {
                const optName = typeof opt === 'string' ? opt : (opt.name || opt);
                if (optName && optName.toLowerCase() === 'personalised') {
                    isPersonalised = true;
                    personalisationOptionIndex = index;
                }
            });
        }
        
        // For personalized products without "Personalised" option, don't show modal
        if (isPersonalised && personalisationOptionIndex === -1) {
            return;
        }
        
        // Find variant option index (prefer "Personalised" for personalized products, then "size", otherwise use first option)
        let variantOptionIndex = 0;
        if (isPersonalised && personalisationOptionIndex >= 0) {
            variantOptionIndex = personalisationOptionIndex;
        } else if (productData.options && Array.isArray(productData.options)) {
            const sizeIndex = productData.options.findIndex(function(opt) {
                // Handle both string options and object options
                const optionName = typeof opt === 'string' ? opt : (opt.name || opt);
                return optionName && optionName.toLowerCase() === 'size';
            });
            if (sizeIndex >= 0) {
                variantOptionIndex = sizeIndex;
            } else {
                // No size option, use first option (index 0)
                variantOptionIndex = 0;
            }
        }
        
        
        // Check if single variant product
        const isSingleVariant = productData.variants && productData.variants.length === 1 && 
                                productData.variants[0].title === "Default Title";
        
        // Build variant buttons (only if not single variant and has variants)
        if (productData.variants && productData.variants.length > 0 && !isSingleVariant) {
            // Reset display style for multi-variant products
            modalSizesContainer.style.display = '';
            let firstAvailableVariant = null;
            
            // For personalized products, only show Yes and No variants
            if (isPersonalised && personalisationOptionIndex >= 0) {
                let yesVariant = null;
                let noVariant = null;
                
                productData.variants.forEach(function(variant) {
                    let personalisationValue = null;
                    if (personalisationOptionIndex === 0 && variant.option1) {
                        personalisationValue = variant.option1;
                    } else if (personalisationOptionIndex === 1 && variant.option2) {
                        personalisationValue = variant.option2;
                    } else if (personalisationOptionIndex === 2 && variant.option3) {
                        personalisationValue = variant.option3;
                    } else if (variant.options && variant.options[personalisationOptionIndex]) {
                        personalisationValue = variant.options[personalisationOptionIndex];
                    }
                    
                    if (personalisationValue) {
                        const valueLower = personalisationValue.toLowerCase();
                        if (valueLower === 'yes' && !yesVariant) {
                            yesVariant = variant;
                        } else if (valueLower === 'no' && !noVariant) {
                            noVariant = variant;
                        }
                    }
                });
                
                // Create Yes button
                if (yesVariant) {
                    let isAvailable = true;
                    if (yesVariant.inventory_quantity !== undefined && yesVariant.inventory_quantity !== null) {
                        if (yesVariant.inventory_management === 'shopify' && yesVariant.inventory_policy === 'deny') {
                            isAvailable = yesVariant.inventory_quantity > 0;
                        } else {
                            isAvailable = true;
                        }
                    } else if (yesVariant.available !== undefined && yesVariant.available !== null) {
                        isAvailable = yesVariant.available === true || yesVariant.available === 'true' || yesVariant.available === 1 || yesVariant.available === '1';
                    }
                    
                    if (!firstAvailableVariant && isAvailable) {
                        firstAvailableVariant = yesVariant;
                    }
                    
                    const btn = document.createElement('button');
                    btn.type = 'button';
                    btn.className = 'bfs-quick-add-modal__size-btn';
                    if (!isAvailable) {
                        btn.classList.add('is-unavailable');
                        btn.disabled = true;
                    }
                    btn.textContent = 'Yes';
                    btn.setAttribute('data-variant-id', yesVariant.id);
                    btn.setAttribute('data-variant-available', isAvailable ? 'true' : 'false');
                    btn.setAttribute('data-product-handle', productHandle);
                    btn.setAttribute('data-is-personalised', 'true');
                    
                    btn.addEventListener('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        
                        const btnAvailable = this.getAttribute('data-variant-available') === 'true';
                        if (!btnAvailable) return;
                        
                        const btnProductHandle = this.getAttribute('data-product-handle');
                        if (btnProductHandle) {
                            window.location.href = '/products/' + btnProductHandle + '?variant=' + yesVariant.id;
                        }
                    });
                    
                    modalSizesContainer.appendChild(btn);
                }
                
                // Create No button
                if (noVariant) {
                    let isAvailable = true;
                    if (noVariant.inventory_quantity !== undefined && noVariant.inventory_quantity !== null) {
                        if (noVariant.inventory_management === 'shopify' && noVariant.inventory_policy === 'deny') {
                            isAvailable = noVariant.inventory_quantity > 0;
                        } else {
                            isAvailable = true;
                        }
                    } else if (noVariant.available !== undefined && noVariant.available !== null) {
                        isAvailable = noVariant.available === true || noVariant.available === 'true' || noVariant.available === 1 || noVariant.available === '1';
                    }
                    
                    if (!firstAvailableVariant && isAvailable) {
                        firstAvailableVariant = noVariant;
                    }
                    
                    const btn = document.createElement('button');
                    btn.type = 'button';
                    btn.className = 'bfs-quick-add-modal__size-btn';
                    if (!isAvailable) {
                        btn.classList.add('is-unavailable');
                        btn.disabled = true;
                    }
                    btn.textContent = 'No';
                    btn.setAttribute('data-variant-id', noVariant.id);
                    btn.setAttribute('data-variant-available', isAvailable ? 'true' : 'false');
                    btn.setAttribute('data-product-handle', productHandle);
                    btn.setAttribute('data-is-personalised', 'true');
                    
                    btn.addEventListener('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        
                        const btnAvailable = this.getAttribute('data-variant-available') === 'true';
                        if (!btnAvailable) return;
                        
                        // Remove previous selection
                        modalSizesContainer.querySelectorAll('.bfs-quick-add-modal__size-btn').forEach(function(b) {
                            b.classList.remove('is-selected');
                        });
                        
                        // Add selection
                        btn.classList.add('is-selected');
                        currentSelectedVariantId = noVariant.id;
                        
                        // Add to cart immediately for "No"
                        addToCart(noVariant.id, btn, false).then(function() {
                            // Close modal after adding
                            setTimeout(function() {
                                closeModal();
                            }, 1000);
                        }).catch(function(error) {
                            console.error('Error adding to cart:', error);
                        });
                    });
                    
                    modalSizesContainer.appendChild(btn);
                }
            } else {
                // For non-personalized products, show all variants
                productData.variants.forEach(function(variant) {
                // Shopify variants use option1, option2, option3 properties
                let variantValue = null;
                if (variantOptionIndex === 0 && variant.option1) {
                    variantValue = variant.option1;
                } else if (variantOptionIndex === 1 && variant.option2) {
                    variantValue = variant.option2;
                } else if (variantOptionIndex === 2 && variant.option3) {
                    variantValue = variant.option3;
                } else if (variant.options && variant.options[variantOptionIndex]) {
                    // Fallback to options array if it exists
                    variantValue = variant.options[variantOptionIndex];
                }
                
                if (!variantValue) {
                    console.warn('Variant value not found for variant:', variant);
                    return; // Skip this variant if we can't find the value
                }
                
                // Check availability - Match product page logic: check inventory_quantity > 0
                // On live sites, the JSON API might return different data than Liquid
                let isAvailable = true; // Default to available
                
                // Priority 1: Check inventory_quantity (most reliable)
                // Match the product page logic: if inventory_quantity > 0, it's available
                if (variant.inventory_quantity !== undefined && variant.inventory_quantity !== null) {
                    // Check if inventory tracking is enabled
                    if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
                        // Tracked inventory with deny policy: must have quantity > 0
                        isAvailable = variant.inventory_quantity > 0;
                    } else if (variant.inventory_management === 'shopify' && variant.inventory_policy === 'continue') {
                        // Tracked inventory with continue policy: always available (backorders allowed)
                        isAvailable = true;
                    } else {
                        // No inventory tracking or not set: assume available
                        isAvailable = true;
                    }
                } else if (variant.available !== undefined && variant.available !== null) {
                    // Priority 2: Use 'available' property if inventory_quantity is not present
                    // Handle both boolean and string values
                    isAvailable = variant.available === true || variant.available === 'true' || variant.available === 1 || variant.available === '1';
                }
                // If neither exists, default to true (assume available)
                const variantId = variant.id;
                
                
                // Track first available variant for auto-selection
                if (!firstAvailableVariant && isAvailable) {
                    firstAvailableVariant = variant;
                }
                
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'bfs-quick-add-modal__size-btn';
                if (!isAvailable) {
                    btn.classList.add('is-unavailable');
                    btn.disabled = true;
                }
                btn.textContent = variantValue;
                btn.setAttribute('data-variant-id', variantId);
                btn.setAttribute('data-variant-available', isAvailable ? 'true' : 'false');
                btn.setAttribute('data-product-handle', productHandle);
                
                btn.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    const btnAvailable = this.getAttribute('data-variant-available') === 'true';
                    if (!btnAvailable) return;
                    
                    const variantValueLower = this.textContent.trim().toLowerCase();
                    const btnIsPersonalised = this.getAttribute('data-is-personalised') === 'true';
                    const btnProductHandle = this.getAttribute('data-product-handle');
                    
                    // If personalized product and user clicked "Yes" or "No", navigate to PDP
                    if (btnIsPersonalised && (variantValueLower === 'yes' || variantValueLower === 'no')) {
                        if (btnProductHandle) {
                            window.location.href = '/products/' + btnProductHandle + '?variant=' + variantId;
                        } else {
                            console.error('Product handle not found for personalized variant');
                        }
                        return;
                    }
                    
                    // Remove previous selection
                    modalSizesContainer.querySelectorAll('.bfs-quick-add-modal__size-btn').forEach(function(b) {
                        b.classList.remove('is-selected');
                    });
                    
                    // Add selection
                    btn.classList.add('is-selected');
                    currentSelectedVariantId = variantId;
                    modalAddBtn.disabled = false;
                });
                
                modalSizesContainer.appendChild(btn);
            });
            
            // Auto-select first available variant and enable add to cart button
            if (firstAvailableVariant) {
                const firstBtn = modalSizesContainer.querySelector('[data-variant-id="' + firstAvailableVariant.id + '"]');
                if (firstBtn) {
                    firstBtn.classList.add('is-selected');
                    currentSelectedVariantId = firstAvailableVariant.id;
                    modalAddBtn.disabled = false;
                }
            }
        }
        } else if (isSingleVariant && productData.variants && productData.variants.length > 0) {
            // Single variant product - hide sizes container and auto-select the variant
            modalSizesContainer.style.display = 'none';
            const singleVariant = productData.variants[0];
            currentSelectedVariantId = singleVariant.id;
            modalAddBtn.disabled = false;
        } else {
            // No variants found, ensure button is disabled
            modalSizesContainer.style.display = '';
            modalAddBtn.disabled = true;
        }
        
        // Show/hide header and set title based on personalization
        if (modalHeader && modalTitle) {
            if (isPersonalised) {
                modalTitle.textContent = 'Add personalisation?';
                modalHeader.style.display = 'block';
            } else {
                modalHeader.style.display = 'none';
            }
        }
        
        // Reset modal button text and styles (disabled state is already set by auto-selection above)
        modalAddBtn.textContent = 'Add to cart';
        modalAddBtn.classList.remove('is-adding', 'is-added');
        modalAddBtn.style.background = '';
        
        // Show modal
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    }
    
    // Close modal
    function closeModal() {
        if (!modal) return;
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        currentSelectedVariantId = null;
        
        // Reset header visibility
        if (modalHeader) {
            modalHeader.style.display = 'none';
        }
    }
    
    // Close on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal && modal.getAttribute('aria-hidden') === 'false') {
            closeModal();
        }
    });

    // Add to cart function (reusable)
    function addToCart(variantId, buttonElement, isMobileIcon) {
        if (!variantId) {
            console.error('No variant ID provided');
            return Promise.reject(new Error('No variant ID provided'));
        }
        
        const originalText = buttonElement ? buttonElement.textContent : '';
        
        if (buttonElement) {
            buttonElement.disabled = true;
            buttonElement.classList.add('is-adding');
            
            // For mobile icons and variant size buttons, just add the is-adding class (CSS handles spinner)
            const isVariantButton = buttonElement.classList.contains('bfs-product-card__quick-add-size');
            if (!isMobileIcon && !buttonElement.classList.contains('bfs-product-card__quick-add-icon') && !isVariantButton) {
                buttonElement.textContent = 'Adding...';
            }
        }
        
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        })
        .then(function(response) {
            if (!response.ok) {
                return response.json().then(function(data) {
                    throw new Error(data.description || 'Failed to add to cart');
                });
            }
            return response.json();
        })
        .then(function(item) {
            // Success
            if (buttonElement) {
                buttonElement.classList.remove('is-adding');
                
                // For mobile icons and variant size buttons, just remove is-adding class (icon/text shows again)
                const isVariantButton = buttonElement.classList.contains('bfs-product-card__quick-add-size');
                if ((isMobileIcon && buttonElement.classList.contains('bfs-product-card__quick-add-icon')) || isVariantButton) {
                    // Icon/text is already visible (CSS animation stops), just enable button and restore selection state
                    buttonElement.disabled = false;
                    if (isVariantButton) {
                        // Keep the selected state for variant buttons
                        buttonElement.classList.add('is-selected');
                    }
                } else {
                    buttonElement.classList.add('is-added');
                    buttonElement.textContent = 'Added!';
                    
                    // Reset button after delay
                    setTimeout(function() {
                        buttonElement.classList.remove('is-added');
                        buttonElement.textContent = originalText;
                        buttonElement.disabled = false;
                    }, 2000);
                }
            }
            
            // Update cart count if function exists
            if (typeof window.updateCart !== 'undefined') {
                window.updateCart();
            } else if (typeof Shopify !== 'undefined' && typeof Shopify.getCart !== 'undefined') {
                Shopify.getCart(function(cart) {
                    // Trigger cart update event
                    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
                });
            }
            
            // Dispatch custom event for other scripts
            document.dispatchEvent(new CustomEvent('quickadd:added', {
                detail: {
                    variantId: variantId,
                    item: item
                }
            }));
            
            return item;
        })
        .catch(function(error) {
            // Error
            console.error('Quick Add Error:', error);
            if (buttonElement) {
                buttonElement.classList.remove('is-adding');
                
                // For mobile icons and variant size buttons, just remove is-adding class
                const isVariantButton = buttonElement.classList.contains('bfs-product-card__quick-add-size');
                if ((isMobileIcon && buttonElement.classList.contains('bfs-product-card__quick-add-icon')) || isVariantButton) {
                    // Icon/text is already visible, just enable button
                    buttonElement.disabled = false;
                } else {
                    buttonElement.textContent = 'Error';
                    buttonElement.style.background = '#dc3545';
                    
                    setTimeout(function() {
                        buttonElement.textContent = originalText;
                        buttonElement.style.background = '';
                        buttonElement.disabled = false;
                    }, 2000);
                }
            }
            throw error;
        });
    }

    // Mobile icon handling is done by standalone inline script in theme.liquid
    // (captures touchstart before anything else can intercept it)

    // Kept for backward compatibility
    function initMobileQuickAddIcons() {
        // Mobile icon clicks are handled via inline script in theme.liquid
    }

    // Initialize Quick Add functionality
    function initQuickAdd() {
        // First, clear initialization flags for containers that might have been replaced
        // This helps when boost-pfs rebuilds products
        const allContainers = document.querySelectorAll('.bfs-product-card__quick-add[data-initialized]');
        allContainers.forEach(function(container) {
            // Check if container still has buttons (might have been replaced by boost-pfs)
            const hasButtons = container.querySelector('.bfs-product-card__quick-add-size') || container.querySelector('.bfs-product-card__quick-add-btn');
            const hasSizesContainer = container.querySelector('.bfs-product-card__quick-add-sizes');
            const isPersonalised = container.getAttribute('data-is-personalised') === 'true';
            
            // If personalized product container exists but has no buttons, check if it should have them
            if (isPersonalised && hasSizesContainer && !hasButtons) {
                // Personalized product should have buttons if it has Personalised option
                // Clear flag to allow re-initialization - might be a timing issue
                container.removeAttribute('data-initialized');
            } else if (!isPersonalised && hasSizesContainer && !hasButtons) {
                // Non-personalized product with sizes container but no buttons - might have been replaced
                container.removeAttribute('data-initialized');
            }
            // Also check if the container is inside a product card that was just added
            const productCard = container.closest('.bfs-product-card');
            if (productCard && !productCard.hasAttribute('data-quick-add-initialized')) {
                productCard.setAttribute('data-quick-add-initialized', 'true');
                container.removeAttribute('data-initialized');
            }
        });
        
        const quickAddContainers = document.querySelectorAll('.bfs-product-card__quick-add:not([data-initialized])');
        
        quickAddContainers.forEach(function(container) {
            // Skip if container is empty or doesn't have the expected structure
            const hasSizesContainer = container.querySelector('.bfs-product-card__quick-add-sizes');
            const hasButtons = container.querySelector('.bfs-product-card__quick-add-size') || container.querySelector('.bfs-product-card__quick-add-btn');
            const isPersonalised = container.getAttribute('data-is-personalised') === 'true';
            
            // If personalized product container exists but has no buttons, check if it should be empty
            if (isPersonalised && !hasButtons && hasSizesContainer) {
                // Check if sizes container is intentionally empty (personalized without Personalised option)
                const sizesContainer = container.querySelector('.bfs-product-card__quick-add-sizes');
                if (sizesContainer && sizesContainer.children.length === 0) {
                    // This is a personalized product without Personalised option - should be empty, skip initialization
                    container.setAttribute('data-initialized', 'true');
                    return;
                }
            }
            
            // If container has no buttons and no sizes container, it might be malformed - skip it
            if (!hasButtons && !hasSizesContainer) {
                container.setAttribute('data-initialized', 'true');
                return;
            }
            
            // Mark as initialized to prevent double-binding
            container.setAttribute('data-initialized', 'true');
            
            const productId = container.getAttribute('data-product-id');
            const sizeButtons = container.querySelectorAll('.bfs-product-card__quick-add-size');
            const addToCartBtn = container.querySelector('.bfs-product-card__quick-add-btn');
            
            let selectedVariantId = null;
            
            // Check if single variant product
            const singleVariantId = addToCartBtn ? addToCartBtn.getAttribute('data-single-variant-id') : null;
            
            if (singleVariantId && addToCartBtn) {
                // Single variant product - use the variant ID directly
                selectedVariantId = singleVariantId;
                addToCartBtn.disabled = false;
            } else if (sizeButtons.length > 0) {
                // Multi-variant product (no Quick Add button) - set up direct add to cart on variant click
                const isPersonalised = container.getAttribute('data-is-personalised') === 'true';
                const productHandle = container.getAttribute('data-product-handle');
                
                sizeButtons.forEach(function(btn) {
                    btn.addEventListener('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        e.stopImmediatePropagation();
                        
                        const variantId = this.getAttribute('data-variant-id');
                        const isAvailable = this.getAttribute('data-variant-available') === 'true';
                        const variantValue = this.textContent.trim().toLowerCase();
                        const btnIsPersonalised = this.getAttribute('data-is-personalised') === 'true';
                        const btnProductHandle = this.getAttribute('data-product-handle') || productHandle;
                        
                        if (!isAvailable || !variantId) {
                            return false;
                        }
                        
                        // Check if this is a personalized product
                        if ((isPersonalised || btnIsPersonalised)) {
                            if (variantValue === 'yes') {
                                // Navigate to product page with variant selected
                                if (btnProductHandle) {
                                    window.location.href = '/products/' + btnProductHandle + '?variant=' + variantId;
                                } else {
                                    console.error('Product handle not found for personalized variant');
                                }
                                return false;
                            } else if (variantValue === 'no') {
                                // For "No", add to cart directly (if in stock)
                                // Remove previous selection
                                sizeButtons.forEach(function(b) {
                                    b.classList.remove('is-selected');
                                });
                                
                                // Add selection to clicked button
                                this.classList.add('is-selected');
                                
                                // Add to cart directly
                                addToCart(variantId, this).catch(function(error) {
                                    console.error('Quick Add Error:', error);
                                });
                                
                                return false;
                            }
                        }
                        
                        // Remove previous selection
                        sizeButtons.forEach(function(b) {
                            b.classList.remove('is-selected');
                        });
                        
                        // Add selection to clicked button
                        this.classList.add('is-selected');
                        
                        // Add to cart directly (for non-personalized variants)
                        addToCart(variantId, this).catch(function(error) {
                            console.error('Quick Add Error:', error);
                        });
                        
                        return false;
                    });
                });
            }
            
            // Handle add to cart (only if button exists - single variant products)
            if (addToCartBtn) {
                addToCartBtn.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    
                    if (!selectedVariantId || this.disabled || this.classList.contains('is-adding')) {
                        return false;
                    }
                    
                    // Use reusable addToCart function
                    addToCart(selectedVariantId, this).catch(function(error) {
                        console.error('Quick Add Error:', error);
                    });
                    return false;
                });
            }
            
            // Prevent card link from firing when clicking on quick add container (but allow buttons to work)
            container.addEventListener('click', function(e) {
                // Only prevent if clicking on the container itself, not on buttons inside
                if (e.target === container || (!e.target.closest('.bfs-product-card__quick-add-size') && !e.target.closest('.bfs-product-card__quick-add-btn'))) {
                    e.stopPropagation();
                }
            });
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initQuickAdd();
            initMobileQuickAddIcons();
        });
    } else {
        initQuickAdd();
        initMobileQuickAddIcons();
    }
    
    // Re-initialize for dynamically loaded content (e.g., AJAX filters)
    document.addEventListener('DOMContentLoaded', function() {
        // Use MutationObserver to watch for new product cards
        const observer = new MutationObserver(function(mutations) {
            let shouldReinit = false;
            mutations.forEach(function(mutation) {
                // Check for added nodes
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) {
                        if (node.classList && node.classList.contains('bfs-product-card__quick-add')) {
                            shouldReinit = true;
                        } else if (node.querySelector && node.querySelector('.bfs-product-card__quick-add')) {
                            shouldReinit = true;
                        } else if (node.classList && node.classList.contains('bfs-product-card')) {
                            shouldReinit = true;
                        }
                    }
                });
                // Also check for removed nodes (HTML replacement)
                if (mutation.removedNodes && mutation.removedNodes.length > 0) {
                    mutation.removedNodes.forEach(function(node) {
                        if (node.nodeType === 1 && node.classList && node.classList.contains('bfs-product-card__quick-add')) {
                            shouldReinit = true;
                        }
                    });
                }
            });
            
            if (shouldReinit) {
                // Small delay to ensure DOM is fully updated
                setTimeout(function() {
                    initQuickAdd();
                    initMobileQuickAddIcons();
                }, 200);
            }
        });
        
        const container = document.body;
        if (container) {
            observer.observe(container, {
                childList: true,
                subtree: true,
                attributes: false,
                characterData: false
            });
        }
        
        // Also do a periodic check for the first few seconds after page load
        let checkCount = 0;
        const maxChecks = 5;
        const checkInterval = setInterval(function() {
            checkCount++;
            const uninitialized = document.querySelectorAll('.bfs-product-card__quick-add:not([data-initialized])');
            if (uninitialized.length > 0) {
                initQuickAdd();
                initMobileQuickAddIcons();
            }
            if (checkCount >= maxChecks) {
                clearInterval(checkInterval);
            }
        }, 1000);
    });
    
    // Listen for boost-pfs events and other dynamic content events
    if (typeof window !== 'undefined') {
        // Function to re-initialize with multiple attempts
        function reinitQuickAdd() {
            setTimeout(function() {
                initQuickAdd();
                initMobileQuickAddIcons();
            }, 100);
            setTimeout(function() {
                initQuickAdd();
                initMobileQuickAddIcons();
            }, 300);
            setTimeout(function() {
                initQuickAdd();
                initMobileQuickAddIcons();
            }, 600);
        }
        
        window.addEventListener('boost-pfs-filter-products-loaded', reinitQuickAdd);
        window.addEventListener('boost-pfs-filter-render-complete', reinitQuickAdd);
        window.addEventListener('boost-pfs-ajax-complete', reinitQuickAdd);
        window.addEventListener('boost-pfs-filter-after-processing', reinitQuickAdd);
        
        // Re-initialize after window load to catch any products that might have been loaded
        window.addEventListener('load', function() {
            setTimeout(function() {
                initQuickAdd();
                initMobileQuickAddIcons();
            }, 500);
            setTimeout(function() {
                initQuickAdd();
                initMobileQuickAddIcons();
            }, 1000);
            setTimeout(function() {
                initQuickAdd();
                initMobileQuickAddIcons();
            }, 2000);
        });
        
        // Also listen for any DOM mutations that might indicate product cards were replaced
        var loadObserver = new MutationObserver(function(mutations) {
            var shouldReinit = false;
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length > 0) {
                    for (var i = 0; i < mutation.addedNodes.length; i++) {
                        var node = mutation.addedNodes[i];
                        if (node.nodeType === 1 && node.querySelector && node.querySelector('.bfs-product-card__quick-add')) {
                            shouldReinit = true;
                            break;
                        }
                    }
                }
            });
            if (shouldReinit) {
                setTimeout(function() {
                    initQuickAdd();
                    initMobileQuickAddIcons();
                }, 200);
            }
        });
        
        // Start observing after a short delay to avoid interfering with initial load
        setTimeout(function() {
            if (document.body) {
                loadObserver.observe(document.body, {
                    childList: true,
                    subtree: true
                });
            }
        }, 2000);
    }
    
})();
